import React, { useState } from "react";
import { useSelector } from "react-redux";
const MenuPdf = () => {
    const url = useSelector(state => state.digitalMenuConfig.url);
    return (
        <div>
            <iframe src={url} frameBorder="0" height="100%" width="100%"/>
        </div>
    )
}


export default MenuPdf;